/* eslint-disable react/jsx-no-bind*/
import React from 'react';
import _ from 'lodash';

class Tags extends React.Component {
  constructor(props) {
    super(props);
  }

  assignTag = (tag) => {
    this.props.assignTag(tag);
  };

  contentTags = () => {
    if (this.props.data) {
      let tags = this.props.data.map((category, i) => {
        if (category.value) {
          let activeCssClass = '';
          _.map(this.props.cssActiveClassForSelectedTags, (rowTagId) => {
            if (rowTagId === category.key.toString()) {
              activeCssClass = 'active';
            }
          });
          return (
            <li key={i}>
              <span
                onClick={this.assignTag.bind(this, category)}
                className={`icon icon-tag ${activeCssClass} ${this.props.getClass(
                  category.id
                )}`}
              >
                {category.value}
              </span>
            </li>
          );
        }
        return tags;
      });

      return <ul>{tags}</ul>;
    }
  };

  render() {
    return (
      <div
        className={`tag-list ${this.props.noTagSelection ? 'tagIndex' : ''}`}
      >
        <span
          className="icon icon-information float-right"
          onClick={this.props.onTagInfoClick}
        />
        {this.contentTags()}
      </div>
    );
  }
}

export default Tags;
